import { supabase } from '../SupabaseClient/supabase-client';

export type ProventoAsset = {
  ticker: string;
  type: string;
  quantity: number;
  lastDividendValue: number;
  lastDividendDate: string | null;
  projectedAmount: number;
};

export type MonthlyTotal = {
  month: string;
  total: number;
  fiiTotal: number;
  otherTotal: number;
};

export type ProventosData = {
  nextMonthProjection: {
    fiiTotal: number;
    otherTotal: number;
  };
  assets: ProventoAsset[];
  monthlyHistory: MonthlyTotal[];
};

const FUNCTION_NAME = 'proventos';

export const proventosService = {
  async getProventos(): Promise<ProventosData> {
    const { data, error } = await supabase.functions.invoke(FUNCTION_NAME);
    if (error) throw error;

    const payload = (data && typeof data === 'object' ? data : {}) as Record<string, unknown>;

    const projection = (payload.nextMonthProjection && typeof payload.nextMonthProjection === 'object'
      ? payload.nextMonthProjection
      : {}) as Record<string, unknown>;

    return {
      nextMonthProjection: {
        fiiTotal: Number(projection.fiiTotal ?? 0),
        otherTotal: Number(projection.otherTotal ?? 0),
      },
      assets: Array.isArray(payload.assets) ? (payload.assets as ProventoAsset[]) : [],
      monthlyHistory: Array.isArray(payload.monthlyHistory)
        ? (payload.monthlyHistory as MonthlyTotal[])
        : [],
    };
  },
};
